<div class="jumbotron">
    <h1 class="display-4">Sorry</h1>
    <p class="lead">
        We can't accommodate you right now. Please contact the clinic on
        <a href="tel:+612 9302 2888">+612 9302 2888</a> before making an
        appointment or attending the clinic
    </p>
</div>